import { connect } from "react-redux";
import EgiftCardsEmailWindow from "../components/_EgiftCardsEmailWindow";
import * as actions from "../../../_actions/order";

const mapStateToProps = ({ EgiftCardsEmail, Misc }) => ({
    loading: EgiftCardsEmail.fetching.loading,
    err: EgiftCardsEmail.fetching.err,
    language: Misc.language.language,
    store: Misc.store.store
});

const mapDispatchToProps = dispatch => ({
    sendEgiftCardsEmail: orderId => {
        dispatch(actions.sendEgiftCardsEmail(orderId));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(EgiftCardsEmailWindow);
